import React from "react";

export interface IProps {
  page: number;
  totalPages: number;
  itemsPerPage: number;
  totalItems: number;
  translation?: string;
}

const PaginationInfo = ({ page, totalPages, itemsPerPage, totalItems, translation }: IProps) => {
  const to = totalPages === page ? totalItems : itemsPerPage * page;
  const from = (page - 1) * itemsPerPage + 1;
  const text = translation
    ? translation
        .replace("{{from}}", `${from}`)
        .replace("{{to}}", `${to}`)
        .replace("{{total}}", `${totalItems}`)
    : `Showing items ${from} - ${to} of ${totalItems}`;
  return <p className="mb-4 text-center text-sm text-tertiary-6">{text}</p>;
};

export default PaginationInfo;
